import { FC } from "react";
import { Heading, Stack } from "@chakra-ui/react";

import { capitalize, formatDate, isValidDate } from "../../../../../utils";

interface Props {
  date: string | undefined;
}

export const OperationItemMonth: FC<Props> = ({ date }) => {
  const month = isValidDate(date)
    ? capitalize(formatDate(new Date(date!), { day: undefined }))
    : "";

  const currentYear = (new Date()).getFullYear();
  const operationYear = isValidDate(date) ? Number(date!.substring(0, 4)) : "";
  const year = currentYear === operationYear ? "" : operationYear;

  return (
  // Для бесконечного скрола важно чтобы у элемента была фиксированная высота и без margin
    <Stack h="48px" pb="10px" justifyContent="center">
      <Heading fontSize="2xl">
        {month}
        {" "}
        {year}
      </Heading>
    </Stack>
  );
};
